import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LOAD_DATA,
  EJECUTAR_ACCION,
  msgError,
  statusPage,
  loadData,
  msgSuccess,
  // logout,
  estadoPaginaAccion,
  msgAdvertencia,
  // limpiarMensaje,
  // msgInformacion,
} from '../actions';
import {
  withloadAsync,
  withPostPutDeleteAsync,
  // withUploadAsync,
  // getFormImage,
  // downloadAsync,
} from '../api';
// import {
// URL_DOWNLOAD_ARCHIVE,
// API_BASE_URL,
// } from '../DefaultUri';
import {
  getMessage,
  generateParametersToUrl,
  // getStringDate,
} from '../../helpers/Utils';

function* withData({ payload }) {
  try {
    const { query, method, token } = payload;
    const {
      // archivo,
      currentQuery,
    } = query;
    let resultParam = null;
    let currentQueryParam = null;
    let queryArchivoParam = null;
    switch (method) {
      case 'GET':
        resultParam = yield call(
          withloadAsync,
          generateParametersToUrl(query.data),
          token,
          query.URI
        );
        if (resultParam.success) {
          yield put(
            statusPage({
              load: true,
              keyPage: query.keyPage,
              data: resultParam,
            })
          );
        } /* else if (resultParam.msg === 'Token Expidado') {
              yield put(logout())
            } */ else {
          yield put(msgAdvertencia(resultParam.msg));
        }
        if (query.callbackResult) {
          query.callbackResult(resultParam);
        }
        break;
      default:
        currentQueryParam = currentQuery;
        queryArchivoParam = query.query_Archivo;
        resultParam = yield call(
          withPostPutDeleteAsync,
          Object.assign(query, {
            currentQuery: null,
            query_Archivo: null,
          }),
          method,
          token,
          currentQueryParam.URI
        );
        if (!resultParam.success) {
          // if (resultParam.msg === 'Token Expidado') {
          // yield put(logout());
          // } else {
          yield put(msgAdvertencia(resultParam.msg));
          // }
        } else {
          yield put(msgSuccess(resultParam.msg));
        }
        if (currentQueryParam) {
          if (currentQueryParam.data) {
            yield put(
              loadData(
                {
                  ...currentQueryParam,
                  callbackResult: false,
                },
                'GET'
              )
            );
          }
        }
        if (queryArchivoParam) {
          if (Array.isArray(queryArchivoParam)) {
            for (let i = 0; i < queryArchivoParam.length; i += 1) {
              yield put(loadData(queryArchivoParam[0], 'UPLOAD'));
            }
          } else {
            yield put(loadData(queryArchivoParam, 'UPLOAD'));
          }
        }
        if (currentQueryParam) {
          if (currentQueryParam.callbackResult) {
            currentQueryParam.callbackResult(resultParam);
          }
        }
        break;
      /* case 'UPLOAD':
          currentQueryParam = currentQuery;
          resultParam = yield call(withPostPutDeleteAsync, Object.assign(query,{ archivo: null, currentQuery: null }), query.method ? query.method : 'POST', token, currentQueryParam.URI)
          if (!resultParam.success) {
            // if (resultParam.msg === 'Token Expidado') {
              // yield put(logout());
            // }else{
              yield put(msgAdvertencia(resultParam.msg));
            // }
          }else{
            yield put(msgSuccess(resultParam.msg));
            if (archivo) {
              const resultParamArchivo = yield call(withUploadAsync,
                getFormImage(
                  archivo,
                  resultParam.data.id,
                  currentQueryParam.tabla,
                  query.nombre
                ),
                token,
                currentQueryParam.URL_UPLOAD ? currentQueryParam.URL_UPLOAD : undefined,
              );
              if (!resultParamArchivo.success) {
                yield put(msgAdvertencia(resultParamArchivo.msg));
              } else {
                yield put(msgSuccess('Archivo subido correctamente'));
              }
            }
          }
          if (currentQueryParam) {
            if (currentQueryParam.data) {
              yield put(loadData(currentQueryParam, 'GET'));
            } else if (currentQueryParam.callbackResult) {
              currentQueryParam.callbackResult(resultParam);
            }
          }
          break; */
      /* case 'DOWNLOAD':
            yield call(
              downloadAsync,
              query.nombreArchivo,
              generateParametersToUrl(query.data),
              token,
              query.URI
                ? query.URI
                : URL_DOWNLOAD_ARCHIVE,
              query.target
            );
            yield put(limpiarMensaje(''));
          break; */
      /* case 'DOWNLOADALL':
            for (let i = 0; i < query.length; i += 1) {
              const element = query[i];
              window.open(API_BASE_URL.concat(element.URI ? element.URI : URL_DOWNLOAD_ARCHIVE, '?token=', token, generateParametersToUrl(element.data)));
            }
            yield put(limpiarMensaje(''));
          break; */
      /* case 'EXCEL':
            yield call(downloadAsync, query.nombreArchivo, generateParametersToUrl(query.data), token, query.URI);
            yield put(limpiarMensaje(''));
          break; */
    }
  } catch (error) {
    yield put(msgError(getMessage(error)));
  }
}

export function* watchData() {
  yield takeEvery(LOAD_DATA, withData);
}

// ejecutar acción
function* withDataEjecutar({ payload }) {
  const { data, method, URL, token, llamar } = payload;
  // let strDate = '';
  try {
    let resultParam = null;
    // let formData = null;
    switch (method) {
      case 'GET':
        // ejecutar la consulta de datos
        resultParam = yield call(
          withloadAsync,
          generateParametersToUrl(data),
          token,
          URL
        );
        break;
      /* case 'UPLOAD':
        formData = new FormData();
        Object.entries(data).forEach(([campo, val]) => {
          formData.append(campo, val);
        });
        resultParam = yield call(withUploadAsync, formData, token, URL);
        break; */
      /* case 'EXPORTAR':
        yield put(msgInformacion('Iniciando Descarga'));
        strDate = getStringDate(new Date()).split(' ').join('').split(':').join('').split('-').join('');
        yield call(downloadAsync, `${data.nombreArchivo.split('.')[0]} ${strDate}.${data.nombreArchivo.split('.')[1]}`, generateParametersToUrl(data), token, URL, data.target);
        return; */
      default:
        resultParam = yield call(
          withPostPutDeleteAsync,
          data,
          method,
          token,
          URL
        );
        break;
    }
    // mostrar mensaje correspondiente
    if (resultParam.success) {
      yield put(msgSuccess(getMessage(resultParam)));
    } else {
      yield put(msgAdvertencia(getMessage(resultParam)));
    }
    // si tiene la variable de clavePagina guardar el estado correspondiente
    if (data.clavePagina) {
      yield put(
        estadoPaginaAccion({
          clavePagina: data.clavePagina,
          values: {
            data: resultParam.data,
          },
        })
      );
    }
    if (typeof llamar === 'function') {
      llamar(resultParam);
    }
  } catch (error) {
    yield put(msgError(getMessage(error)));
    if (typeof llamar === 'function') {
      llamar({ success: false, error });
    }
  }
}

// Mejoramiento sin tanta validaciones estupidas
export function* watchDataEjecutar() {
  yield takeEvery(EJECUTAR_ACCION, withDataEjecutar);
}

export default function* rootSaga() {
  yield all([fork(watchData), fork(watchDataEjecutar)]);
}
